<template>
    <el-container style="display: flex">
        <!-- 左侧菜单 -->
        <el-aside :width="isCollapse ? '64px' : '250px'" class="sidebar-container">
            <el-container>
                <div class="aside" style="flex:1">
                    <el-menu 
                        default-active="homepage" 
                        class="el-menu-vertical-demo"
                        :collapse="isCollapse" 
                        unique-opened 
                        style="min-height:100vh;border-right: none;" 
                        router>
                        <!-- Logo和品牌名称 -->
                        <div class="sidebar-brand" :class="{ 'collapsed': isCollapse }">
                            <div class="brand-logo">
                                <img src="../assets/logo.jpg" alt="送呗Logo">
                            </div>
                            <transition name="fade">
                                <span v-if="!isCollapse" class="brand-text">送呗Songbay</span>
                            </transition>
                        </div>
                        
                        <el-menu-item index="/homepage">
                            <i class="el-icon-s-home"></i>
                            <span slot="title">首页</span>
                        </el-menu-item>
                        
                        <el-submenu :index="String(index)" v-for="(item, index) in menuList" :key="item.menuId">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{ item.menuName }}</span>
                            </template>
                            <el-menu-item-group v-for="(item1, index) in item.children" :key="item1.menuId">
                                <el-menu-item :index="item1.path">
                                    <i :class="item1.icon"></i>{{ item1.menuName }}
                                </el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                </div>
            </el-container>
        </el-aside>
        
        <!-- 右侧内容区 -->
        <el-container class="main-container">
            <!-- 顶部导航栏 -->
            <el-header class="header-container">
                <div class="header-content">
                    <div class="header-left">
                        <div class="collapse-btn" @click="fold()">
                            <i class="el-icon-s-fold" v-if="!isCollapse"></i>
                            <i class="el-icon-s-unfold" v-else></i>
                        </div>
                        <el-breadcrumb separator="/" class="breadcrumb">
                            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ currentPathName }}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    
                    <div class="header-right">
                        <el-dropdown trigger="click" @command="handleCommand">
                            <div class="user-dropdown">
                                <el-avatar :src="userAvatar" :size="36"></el-avatar>
                                <span class="user-name">{{ userName }}</span>
                                <i class="el-icon-arrow-down"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                                <el-dropdown-item command="profile" icon="el-icon-user">个人中心</el-dropdown-item>
                                <el-dropdown-item command="logout" icon="el-icon-switch-button" divided>退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>
            
            <!-- 主要内容区 -->
            <el-main class="content-main">
                <transition name="fade-transform" mode="out-in">
                    <router-view :key="$route.fullPath"></router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
export default {
    computed: {
        currentPathName() {
            return this.$store.state.currentPathName;
        }
    },
    watch: {
        currentPathName(newVal, oldVal) {
            console.log(newVal);
        }
    },
    data() {
        return {
            isCollapse: false, // 控制菜单的展开
            userAvatar: '', // 登录用户信息
            userName: '', // 用户名
            menuList: [], // 菜单
            uId: 0,
            communityList: {}, // 小区列表
            communityId: null,
            componentKey: 0,
            schoolList: [
                {
                    id: 1,
                    schoolName: '理工大',
                },
                {
                    id: 2,
                    schoolName: '金融职业学院',
                }
            ]
        };
    },
    created() {
        this.getUser();
    },
    methods: {
        async getUser() {
            const { data: res } = await this.$http.get("user/getUserByToken", {
                params: {
                    token: window.sessionStorage.getItem("token"),
                }
            })
            console.log(res)
            this.userAvatar = res.data.avatar;
            this.userName = res.data.userName;
            window.sessionStorage.setItem('schoolId', res.data.schoolId != null && res.data.schoolId !== 0 ? String(res.data.schoolId) : '');
            window.sessionStorage.setItem('schoolName', res.data.schoolName || '');
            window.sessionStorage.setItem('roleKey', res.data.roleKey || '');
            window.sessionStorage.setItem('schoolScoped', res.data.schoolScoped === true ? 'true' : 'false');
        },
        
        async getMenuList() {
            const { data: res } = await this.$http.get("menu/getMenuListByToken");
            console.log(res)
            this.menuList = res.data;
        },
        
        handleCommand(command) {
            if (command === 'profile') {
                this.personalCenter();
            } else if (command === 'logout') {
                this.signOut();
            }
        },
        
        signOut() {
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.sessionStorage.clear();
                this.$router.push('/login');
                this.$message.success('已退出登录');
            }).catch(() => {});
        },
        
        fold() {
            this.isCollapse = !this.isCollapse;
        },
        
        personalCenter() {
            this.$router.push('/index');
        },
    },
    mounted() {
        this.getMenuList();
    }
}
</script>

<style scoped>
/* 侧边栏容器 */
.sidebar-container {
    background: var(--sidebar-bg);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.08);
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    position: relative;
}

.sidebar-container::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.05));
}

/* Logo品牌区 */
.sidebar-brand {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    margin-bottom: 16px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-brand.collapsed {
    padding: 0;
    justify-content: center;
}

.brand-logo {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 2px;
}

.brand-logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.brand-text {
    margin-left: 14px;
    font-size: 19px;
    font-weight: 700;
    color: var(--sidebar-text);
    white-space: nowrap;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 菜单样式 */
.el-menu-vertical-demo {
    background: transparent !important;
    border-right: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 250px;
}

/* 菜单项 */
.el-menu-item,
.el-submenu__title {
    color: var(--sidebar-text) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 4px 12px;
    border-radius: 10px;
    position: relative;
}

.el-menu-item:hover,
.el-submenu__title:hover {
    background-color: var(--sidebar-hover-bg) !important;
    transform: translateX(4px);
}

.el-menu-item.is-active {
    background-color: var(--sidebar-active-bg) !important;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.el-menu-item.is-active::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 60%;
    background: #ffffff;
    border-radius: 0 4px 4px 0;
}

.el-menu-item i,
.el-submenu__title i {
    color: var(--sidebar-text) !important;
}

::v-deep .el-menu-vertical-demo .el-submenu__title,
::v-deep .el-menu-vertical-demo .el-submenu__title span,
::v-deep .el-menu-vertical-demo .el-submenu__title i {
    color: #ffffff !important;
}

::v-deep .el-menu-vertical-demo > .el-submenu > .el-submenu__title:hover {
    color: #ffffff !important;
    background-color: rgba(0, 62, 55, 0.62) !important;
    transform: translateX(4px);
}

/* 子菜单 */
.el-menu-item-group__title {
    padding: 0;
}

::v-deep .el-submenu .el-menu {
    background: transparent !important;
}

::v-deep .el-submenu .el-menu-item {
    min-width: 0;
    color: #ffffff !important;
    background-color: rgba(0, 74, 65, 0.42) !important;
}

::v-deep .el-submenu .el-menu-item i {
    color: #ffffff !important;
}

::v-deep .el-submenu .el-menu-item:hover {
    color: #ffffff !important;
    background-color: rgba(0, 62, 55, 0.62) !important;
}

::v-deep .el-submenu .el-menu-item.is-active {
    color: #005c52 !important;
    background-color: #f4fffc !important;
    box-shadow: 0 4px 12px rgba(0, 62, 55, 0.22);
}

::v-deep .el-submenu .el-menu-item.is-active i {
    color: #005c52 !important;
}

/* 主容器 */
.main-container {
    background: #f5f7fa;
    max-height: 100vh;
    overflow: hidden;
}

/* 头部导航栏 */
.header-container {
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 194, 168, 0.08);
    padding: 0 32px;
    height: 64px !important;
    line-height: 64px;
    border-bottom: 2px solid rgba(0, 194, 168, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 24px;
}

.collapse-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 22px;
    color: var(--text-secondary);
    border: 2px solid transparent;
}

.collapse-btn:hover {
    background-color: rgba(0, 194, 168, 0.08);
    color: var(--primary-color);
    border-color: rgba(0, 194, 168, 0.2);
    transform: scale(1.05);
}

.collapse-btn:active {
    transform: scale(0.95);
}

.breadcrumb {
    line-height: 64px;
    font-size: 14px;
}

.breadcrumb ::v-deep .el-breadcrumb__inner {
    font-weight: 500;
}

.breadcrumb ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--primary-color);
    font-weight: 600;
}

/* 用户下拉菜单 */
.header-right {
    display: flex;
    align-items: center;
}

.user-dropdown {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
}

.user-dropdown:hover {
    background-color: rgba(0, 194, 168, 0.08);
    border-color: rgba(0, 194, 168, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 194, 168, 0.15);
}

.user-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-dropdown i {
    font-size: 12px;
    color: var(--text-secondary);
}

/* 内容区 */
.content-main {
    padding: 24px;
    overflow-y: auto;
    height: calc(100vh - 64px);
    background: #f5f7fa;
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-transform-enter-active,
.fade-transform-leave-active {
    transition: all 0.3s;
}

.fade-transform-enter {
    opacity: 0;
    transform: translateX(-20px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

/* 滚动条样式 */
.content-main::-webkit-scrollbar {
    width: 6px;
}

.content-main::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

.content-main::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.3);
}

.content-main::-webkit-scrollbar-track {
    background-color: transparent;
}

/* 下拉菜单样式 */
.user-dropdown-menu {
    margin-top: 8px !important;
}
</style>

<style>
/* 全局菜单样式 */
div.el-menu-item-group__title {
    padding: 0 !important;
}
</style>
